export default __webpack_public_path__ + "static/media/thumbnail-rocket.6c671925.jpg";